var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.infoPointRef,class:_vm.classes,style:(`display:${_vm.visibility ? 'block' : 'none'}`),on:{"mouseup":() => false,"mousedown":() => false,"click":_vm.click}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.label)+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }